import { render, staticRenderFns } from "./list.vue?vue&type=template&id=c9c95918&scoped=true"
import script from "./list.vue?vue&type=script&lang=ts"
export * from "./list.vue?vue&type=script&lang=ts"
import style0 from "./list.vue?vue&type=style&index=0&id=c9c95918&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c95918",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9c95918')) {
      api.createRecord('c9c95918', component.options)
    } else {
      api.reload('c9c95918', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=c9c95918&scoped=true", function () {
      api.rerender('c9c95918', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/dealer-wise-os-od-report/list.vue"
export default component.exports